<template>
  <div>
    <div v-if="searchType && searchType !== 'soft'" class="ma-4">
      Sorry, EyeDock cannot find products that are not soft lenses at this time.
    </div>

    <v-card class="my-2 pa-2" :loading="loading">
      <div v-if="q">
        <div class="text-h5 my-2">Searching for soft lenses - "{{ q }}"</div>
      </div>
    </v-card>

    <div v-if="items">
      <v-data-table
        :headers="headers"
        :items="items"
        hide-default-footer
        disable-pagination
        @click:row="handleClick"
        class="pointer"
        dense
      >
        <template v-slot:[`item.image`]="{ item }">
          <img
            v-if="item.image"
            :src="path.lens_images + item.image"
            class="imageIcon"
          />
        </template>
        <template v-slot:[`item.name`]="{ item }">
          <div class="font-weight-bold">{{ item.name }}</div>
        </template>
        <template v-slot:[`item.subtitle`]="{ item }">
          <div class="">{{ item.subtitle }}</div>
        </template>
        <template v-slot:[`item.groups.type`]="{ item }">
          <img
            v-if="item.groups && item.groups.type"
            :src="iconForClType(item.groups.type)"
            class="mx-1 typeIcon"
          />
        </template>
        <template v-slot:[`item.groups.replace`]="{ item }">
          <img
            v-if="item.groups && item.groups.replace"
            :src="iconForClReplace(item.groups.replace)"
            class="mx-1 typeIcon"
          />
        </template>
      </v-data-table>
      <!-- {{ items }} -->
    </div>
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";

// this page is just to deal with links coming in from RevolutionEHR
// they will either contain a lens id or a query (q)
// - https://www.eyedock.com/search-all-lenses?type=soft&q=Total%2030%20for%20Astigmatism
// - https://www.eyedock.com/search-all-lenses?type=soft&tid=480

export default {
  name: "SearchAllLenses",
  props: {},
  data: function () {
    return {
      searchType: null,
      q: null,
      loading: false,
      items: null,
      groups: null,
      tries: 0,
      path: {
        type: "/images/icons/lensTypes/",
        replace: "/images/icons/replace/",
        eyedock: "https://www.eyedock.com",
        lens_images:
          "https://www.eyedock.com/modules/Lenses/pnimages/lens_images/",
      },
      headers: [
        {
          text: "",
          value: "image",
        },
        {
          text: "Lens",
          value: "name",
        },
        {
          text: "Company",
          value: "subtitle",
        },
        {
          text: "Type",
          value: "groups.type",
        },
        {
          text: "Replace",
          value: "groups.replace",
        },
      ],
    };
  },
  methods: {
    doSearch() {
      this.loading = true;
      ApiServices.searchAll(this.q, "CL")
        .then((response) => {
          this.items = response.data.items;
          this.groups = response.data.meta.groups;
          this.loading = false;
          this.checkResults();
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    checkResults() {
      if (!this.items || (this.items.length == 0 && this.tries == 0))
        this.tryAgain();
      if (this.items.length == 1) this.goToId(this.items[0].itemId);
    },
    // if no results truncate the query and try again (but just once)
    tryAgain() {
      this.tries++;
      // get the first word of the query, then truncate it to x letters
      this.q = this.q.split(" ")[0].substring(0, 5);
      this.doSearch();
    },
    goToId(tid) {
      this.$router.push({ path: "/cls/details/" + tid });
    },
    iconForClType(cl_type) {
      let icon = cl_type.toLowerCase();
      return this.path.type + icon + "_icon_active.svg";
    },
    iconForClReplace(replace) {
      let icon = `replace_${replace}`;
      return this.path.replace + icon + "_active.svg";
    },
    handleClick(e) {
      console.log(e);
      this.$router.push({ path: "/cls/details/" + e.slug });
    },
  },
  computed: {},
  mounted() {
    let searchType = this.$route?.query?.type;
    this.searchType = searchType;
    let tid = this.$route?.query?.tid;
    let q = this.$route?.query?.q;
    if (searchType == "soft" && tid && tid > 0) {
      this.goToId(tid);
    } else if (q) {
      this.q = q;
      this.doSearch();
    }
  },
};
</script>

<style scoped>
.imageIcon {
  max-width: 60px;
  max-height: 40px;
}
/* td,
th {
  vertical-align: top;
  text-align: left;
  padding: 2px 15px;
} */
.typeIcon {
  width: 25px;
}
</style>
